import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import agent from '../../agent';
import ArtistRow from './ArtistRow';
import ArtistForm from './ArtistForm';
import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';

const mapDispatchToProps = dispatch => {
  agent.Admin.all(dispatch);
  agent.Mediums.all(dispatch);
  return {
    onArtistClick: (artist) => dispatch({type: 'ADMIN_ARTIST_CLICK', currentArtist: artist})
  }
};

const mapStateToProps = state => ({
  ...state.artists,
  ...state.mediums,
  ...state.admin
});

class ArtistTable extends Component  {

  constructor(props) {
    super(props);

    this.state = {
      showNew: 'none',
      newArtist: '',
      search: ""
    }
  }

  handleNew = event => {
    this.setState({showNew: 'block'});
    this.setState({newArtist: <ArtistForm mediums={this.props.mediums} cancelHandler={this.handleCloseNew} />});
  }

  handleCloseNew = event => {
    this.setState({newArtist: ""});
    this.setState({showNew: 'none'});
  }

  handleSearchChange = value => {
    this.setState({search: value.name.toLowerCase()});
  }

  render() {
    if(!this.props.artists || !this.props.mediums) return null;

    const settings =  {
      showCheckboxes: false,
    };
    const tableStyle = {
      width: "50%",
      minWidth: "1200px",
      margin: 20,
      textAlign: 'center',
      display: 'inline-block',
      fontSize: '24px'
    };
    const headerStyle = {
      fontSize: '18px',
      borderBottom: 'none'
    };
    const rowStyle = {
      borderBottom: 'none'
    }
    const cellStyle = {
      fontSize: '24px',
      height: 'none',
      paddingTop: '10px',
      paddingBottom: '10px',
      cursor: 'pointer'
    };
    const containerStyle = {
      display: 'flex',
      justifyContent: 'center',
    }
    const hintStyle = {

    }

    var artists = this.props.artists.filter( artist => artist.name.toLowerCase().includes(this.state.search) ? true : false);

    return (
      <div style={containerStyle}>
        <div style={tableStyle}>
          <Table selectable={false}>
            <TableHeader
              displaySelectAll={settings.showCheckboxes}
              adjustForCheckbox={settings.showCheckboxes}
              style={headerStyle}
            >
              <TableRow style={rowStyle}>
                <TableHeaderColumn style={headerStyle}>
                  <TextField
                    style={{fontSize: '18px'}}
                    hintText="Search"
                    hintStyle={hintStyle}
                    onChange={e => this.handleSearchChange({name: e.target.value})}
                  />
                </TableHeaderColumn>
                <TableHeaderColumn style={headerStyle}>
                  <FlatButton label="+ New Artist" style={{float:"right"}} onClick={this.handleNew}/>
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={settings.showCheckboxes}
              showRowHover={false}
            >

              <TableRow key="new-artist" hoverable={true} style={{display:this.state.showNew, height: "inherit"}} >
                <TableRowColumn style={cellStyle}>
                  {this.state.newArtist}
                </TableRowColumn>
              </TableRow>

              {artists.map(artist => {
                var totalImages = (artist.images) ? artist.images.length : 0;

                return (
                  <TableRow key={artist.id} hoverable={true}>
                    <TableRowColumn style={cellStyle}>
                      <ArtistRow artist={artist} mediums={this.props.mediums} />
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(ArtistTable);



// WEBPACK FOOTER //
// ./src/components/Admin/ArtistTable.js